<template>
    <div class="container">
        <div class="grid grid-2">
            <div v-if="backVisibility()" class="grid-content middle-start">
                <div>
                    <button class="cs-back btn btn-text text-start" @click="back()">
                        <font-awesome-icon icon="fas fa-angle-left" size="xl" />
                    </button>
                </div>
            </div>

            <div class="grid-content center" style="grid-column: 2 / span 4">
                <div>
                    <h3 class="my-3">{{ $parent.current_title }}</h3>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            back_hidden_view: ["index", "merchant", "merchant_redeem", "voucher", "payment_status"],
        };
    },
    methods: {
        back() {
            if (app.current_view == "voucher_detail") {
                app.voucher_short_id = "";
                app.my_voucher_record_id = "";
                app.redirectToVoucher();
            }

            if (app.current_view == "my_voucher") {
                app.voucher_short_id = "";
                app.my_voucher_record_id = "";
                app.redirectToHome();
            }

            if (app.current_view == "payment_status") {
                app.redirectToHome();
            }
        },

        backVisibility() {
            if (app.current_view) {
                return !this.back_hidden_view.includes(app.current_view);
            }

            return false;
        },
    },
};
</script>